import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlertComponent } from './alert.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TranslateModule } from '@ngx-translate/core';
@NgModule({
  declarations: [AlertComponent],
  imports: [
    CommonModule,
    ModalModule.forRoot(),
    TranslateModule.forChild()
  ],
  exports: [AlertComponent]
})
export class AlertModule { }
